import { CombinedTenantUsersInvitesBoolExp } from '@eluve/graphql-types';

/**
 * Reads the "show excluded users" state out of the data-table filter URL
 * params. The toggle is stored as the faceted-filter array `['true']`.
 */
export const isShowingExcluded = (
  filters: Record<string, string | string[] | null>,
): boolean =>
  Array.isArray(filters.isExcluded) && filters.isExcluded.includes('true');

/**
 * Builds the `where` filter for the org-admin Users table.
 *
 * Excluded users are hidden unless `showExcluded` is on. Invite rows are
 * always visible: the view reports `isExcluded: false` for them, so the
 * default filter never drops an invite.
 */
export const buildUsersListFilter = ({
  tenantId,
  search,
  showExcluded,
}: {
  tenantId: string;
  search: string | null;
  showExcluded: boolean;
}): CombinedTenantUsersInvitesBoolExp => {
  const filterConditions: CombinedTenantUsersInvitesBoolExp[] = [
    { tenantId: { _eq: tenantId } },
  ];

  if (search) {
    filterConditions.push({
      _or: [
        { email: { _ilike: `%${search}%` } },
        { firstName: { _ilike: `%${search}%` } },
        { lastName: { _ilike: `%${search}%` } },
      ],
    });
  }

  if (!showExcluded) {
    filterConditions.push({ isExcluded: { _eq: false } });
  }

  return { _and: filterConditions };
};
